import { render, staticRenderFns } from "./app-settings.vue?vue&type=template&id=36b9d254&scoped=true&"
import script from "./app-settings.vue?vue&type=script&lang=js&"
export * from "./app-settings.vue?vue&type=script&lang=js&"
import style0 from "./app-settings.vue?vue&type=style&index=0&id=36b9d254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9d254",
  null
  
)

export default component.exports